const banks = {
    '010': 'Bank_Markazi',
    '011': 'Sanat_Madan',
    '012': 'Bank_Mellat',
    '013': 'Refah',
    '014': 'Maskan',
    '015': 'Sepah',
    '016': 'Keshavarzi',
    '017': 'Melli',
    '018': 'Tejarat',
    '019': 'Saderat',
    '020': 'Tosee',
    '021': 'Postbank',
    '022': 'Tosee_Taavon',
    '051': 'Mehr_Iran',
    '053': 'Karafarin',
    '054': 'Parsian',
    '055': 'Eghtesad_Novin',
    '056': 'Saman',
    '057': 'Pasargad',
    '058': 'Sarmayeh',
    '059': 'Sina',
    '060': 'Ghavamin',
    '061': 'Bank_Shahr',
    '062': 'Tat',
    '063': 'Ansar',
    '064': 'Gardeshgari',
    '065': 'Hekmat',
    '066': 'Noor',
    '069': 'Iran_Zamin',
};

export const _getBankNameFromIban = (iban: string) => {
    const cleanedIban = iban;
    const ibanRegex = /^IR\d{2}(\d{3})\d{19}$/;

    if (cleanedIban.length === 0) {
        return 'لطفا شماره شبا را وارد نمایید'; // Please enter the IBAN
    } else if (cleanedIban.length !== 26) {
        return 'طول شماره شبا باید ۲۶ حرف باشد'; // The IBAN must be 26 characters long
    } else {
        const parts = cleanedIban.match(ibanRegex);
        if (parts) {
            const bankCode = parts[1];
            return banks[bankCode as keyof typeof banks] || 'کد بانک قابل شناسایی نیست'; // The bank code is not recognized
        } else {
            return 'کد وارد شده نادرست است'; // The entered code is incorrect
        }
    }
};
